<template>
	<v-dialog v-model="show" transition="dialog-bottom-transition" persistent fullscreen>
		<v-card>
			<v-toolbar dark color="secondary">
				<v-card-title>
					<i class="fas fa-question"></i>
					<span class="headline ml-2"> Question </span>
				</v-card-title>
				<v-spacer></v-spacer>
				<button
					type="button"
					class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm"
					@click="close"
				>
					<i class="fal fa-times"></i>
				</button>
			</v-toolbar>
			<v-card-text>
				<v-container class="kt-form">
					<v-row>
						<v-col>
							<v-text-field
								label="Question"
								v-model="form.question"
								multiline
							></v-text-field>
						</v-col>
						<v-col cols="3">
							<v-select
								label="Type"
								:items="questionTypes"
								item-value="slug"
								item-text="title"
								v-model="form.question_type"
								@change="setAnswersType"
							>
							</v-select>
						</v-col>
					</v-row>
					<div v-show="form.question_type === 'multiple'">
						<v-row class="seriesRow">
							<div class="pl-2 toolbar">
								<v-btn
									medium
									class="float-right"
									plain
									color="blue"
									style="color: white !important"
									@click="addAnswer()"
								>
									<v-icon class="mr-2">fa fa-plus</v-icon> Add Answer
								</v-btn>
							</div>
						</v-row>
						<v-row v-for="(answer, index) in form.answers" :key="answer">
							<v-col> <v-text-field v-model="answer.answer"></v-text-field></v-col>
							<v-col cols="1">
								<v-btn icon color="red" @click="removeAnswer(index)">
									<v-icon>fas fa-trash</v-icon>
								</v-btn></v-col
							>
						</v-row>
					</div>
					<v-row>
						<v-col>
							<v-btn color="blue" style="color: white !important" @click="saveQuestion">
								Save Question
							</v-btn>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { each as _each, isEmpty as _isEmpty, isElement } from 'lodash-es';

export default {
  name: 'AddQuestion',
  props: {
    value: {
      default: false,
    },
  },
  data() {
    return {
      questionTypes: [
        {
          title: 'Multiple',
          slug: 'multiple',
        },
        {
          title: 'True or False',
          slug: 'true-or-false',
        },
        {
          title: 'Yes or No',
          slug: 'yes-or-no',
        },
        {
          title: 'Single',
          slug: 'single',
        },
      ],
      form: {
        question: '',
        question_type: 'single',
        answers: '',
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    setAnswersType(value) {
      if (value === 'multiple' || value === 'true-or-false') {
        this.form.answers = [];
      } else {
        this.form.answers = '';
      }
    },
    close() {
      this.show = false;
    },
    addAnswer() {
      this.form.answers.push({
        answer: '',
        is_correct: false,
      });
    },
    removeAnswer(index) {
      this.form.answers.splice(index, 1);
    },
    checkForMultiple() {
      let isAnswerEmpty = false;

      if (!_isEmpty(this.form.answers)) {
        _each(this.form.answers, (answer) => {
          const isEmpty = _isEmpty(answer.answer);
          isAnswerEmpty = isEmpty;
          if (isEmpty) {
            return false;
          }
        });
      }
      if (_isEmpty(this.form.answers) || isAnswerEmpty) {
        this.$notify('warning', 'Please add answer(s)');
        return false;
      }

      return true;
    },
    saveQuestion() {
      let result = false;

      if (this.form.question_type === 'multiple') {
        result = this.checkForMultiple();
      } else if (!_isEmpty(this.form.question)) {
        result = true;
      } else {
        this.$notify('warning', 'Please fill out the question field');
      }

      if (result) {
        this.$store.commit('internetShopCustomForm/addQuestion', this.form);
        this.form = {
          question: '',
          question_type: 'single',
          answers: '',
        };
        this.show = false;
      }
    },
  },
};
</script>

<style scoped lang="stylus">
.nav-anchor
  display none

.navigation
  display none

.toolbar
  background #fafafa
  width 100%

.toolbar i
  cursor pointer
  font-size 15px
</style>
